import { generate } from "shortid";
import { TARGET_DATA } from "../../forms";
import { PAGE_TYPES, PAGE_THEMES } from "../types";

export const ALLIANZ_PAGES = {
  web_payment_setup_account_page_allianz: {
    id: `web_payment_setup_account_page_allianz-${generate()}`,
    type: "web_payment_setup_account_allianz_type",
    backwards_navigation_enabled: true,
    title: null,
    has_header_arch: true,
    module_name: "web_payment",
    target_state: "welcome_data",
    target_field: null,
    theme: PAGE_THEMES.LIGHT,
    target_pages: [
      {
        name: "web_payment_download_page",
        data_key: "description",
        action: (data) => {
          return data;
        },
      },
    ],
    data: {
      title: null,
      description: null,
      image: null,
      options: [],
      custom_back: null,
      default_progression: "web_payment_select_plan_page",
    },
  },
  afq_typeform_page_allianz: {
    id: `afq_typeform_page_allianz-${generate()}`,
    type: "aqf_typeform_allianz_type",
    backwards_navigation_enabled: true,
    title: null,
    has_header_arch: true,
    module_name: "web_payment",
    target_state: "welcome_data",
    target_field: null,
    theme: PAGE_THEMES.LIGHT,
    target_pages: [],
    data: {
      title: null,
      description: null,
      image: null,
      options: [],
      custom_back: null,
      default_progression: "web_payment_select_plan_page",
    },
  },
  therapist_developed_program_allianz: {
    id: `therapist_developed_program_allianz-${generate()}`,
    type: PAGE_TYPES.infoAllianz,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.WARM,
    data: {
      title:
        "Our program is developed by Clinical Psychologists and endorsed by Sydney Phobia Clinic",
      description: "Learn a unique set of skills/techniques to manage anxiety.",
      image: "therapists",
      continue_button_label: "Continue",
      default_progression: "age_select_page",
      options: [],
    },
  },
  program_clinical_lesson_page_allianz: {
    id: `program_clinical_lesson_page_allianz-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "illustrations/program-vr-plan",
      custom_back: null,
      default_progression: "program_exposure_lesson_page_allianz",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "Weeks 1-3",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/program-white",
          text: "Learn from psychologists",
          description:
            "Before you can immerse yourself in the VR exposure therapy, you'll have to complete the psychoeducation first, so you're armed with calming skills and prepared to manage any anxiety the exposure brings up. \n\nOur clinical psychologists have developed audio lessons, exercises, and tools to make learning easy, applicable, and effective.",
          isActive: true,
        },
      ],
    },
  },
  program_exposure_lesson_page_allianz: {
    id: `program_exposure_lesson_page_allianz-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "illustrations/program-vr-plan",
      custom_back: null,
      default_progression: "program_life_lesson_page_allianz",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "Weeks 1-3",
          value: null,
          target_field: null,
          to: null,
          icon: "program",
          text: "Learn from psychologists",
          description:
            "Before you can immerse yourself in the VR exposure therapy, you'll have to complete the psychoeducation first, so you're armed with calming skills and prepared to manage any anxiety the exposure brings up. \n\nOur clinical psychologists have developed audio lessons, exercises, and tools to make learning easy, applicable, and effective.",
          isActive: false,
        },
        {
          id: `step-item-2-${generate()}`,
          label: "Week 4+",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/vr-white",
          text: "VR exposure therapy",
          description:
            "For best results, we recommend that you immerse yourself in VR daily for 20 minutes at a time.",
          isActive: true,
        },
      ],
    },
  },
  program_life_lesson_page_allianz: {
    id: `program_life_lesson_page_allianz-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "illustrations/track-progress",
      custom_back: null,
      default_progression: "program_how_vr_works_page_allianz",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "Weeks 1-3",
          value: null,
          target_field: null,
          to: null,
          icon: "program",
          text: "Learn from psychologists",
          description:
            "Before you can immerse yourself in the VR exposure therapy, you'll have to complete the psychoeducation first, so you're armed with calming skills and prepared to manage any anxiety the exposure brings up. \n\nOur clinical psychologists have developed audio lessons, exercises, and tools to make learning easy, applicable, and effective.",
          isActive: false,
        },
        {
          id: `step-item-2-${generate()}`,
          label: "Week 4+",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/vr-white",
          text: "VR exposure therapy",
          description:
            "For best results, we recommend that you immerse yourself in VR daily for 20 minutes at a time.",
          isActive: false,
        },
        {
          id: `step-item-3-${generate()}`,
          label: "Week 12+",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/reports-white",
          text: "Consistent, lifelong impact",
          description:
            "Track your improvement confronting fears and overcoming avoidance in the real world.",
          isActive: true,
        },
      ],
    },
  },
  program_how_vr_works_page_allianz: {
    id: `program_how_vr_works_page_allianz-${generate()}`,
    type: PAGE_TYPES.summary,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How does VR work?",
      description:
        "We’ll send you a VR headset so you can use your phone to experience VR simulations.",
      image: "illustrations/winking-face",
      custom_back: null,
      default_progression: "web_payment_setup_account_page_allianz",
      options: [
        {
          id: `image-item-1-${generate()}`,
          label: "Insert your mobile phone into the provided headset.",
          value: null,
          target_field: null,
          to: null,
          icon: "vr-headset",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `image-item-2-${generate()}`,
          label: "Pop it on your head and start watching.",
          value: null,
          target_field: null,
          to: null,
          icon: "vr-headset-on-girl",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
};
